import { Collections } from "api";
import { useCallback, useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { useSnackbar } from "notistack";
import { functions } from "config/firebaseConfig";

interface UseClearRaceResultsReturn {
    clearRaceResults: (championshipId: string, raceId: string) => void;
    updating: boolean;
}

export const useClearRaceResults = (): UseClearRaceResultsReturn => {
    const [updating, setUpdating] = useState(false);
    const firestore = useFirestore();
    const { enqueueSnackbar } = useSnackbar();

    const clearRaceResults = useCallback(
        (championshipId: string, raceId: string) => {
            setUpdating(true);

            firestore
                .collection(Collections.RACES)
                .doc(raceId)
                .update({ results: [] })
                .then(() =>
                    functions.httpsCallable("results-calculateStandings")({
                        championshipId,
                    })
                )
                .then(() => {
                    enqueueSnackbar("Resultados removidos com sucesso!", {
                        variant: "success",
                    });
                })
                .catch(() =>
                    enqueueSnackbar(
                        "Não possível remover o resultado desta corrida!",
                        { variant: "error" }
                    )
                )
                .finally(() => setUpdating(false));
        },
        [enqueueSnackbar, firestore]
    );

    return {
        clearRaceResults,
        updating,
    };
};
